module.exports = __webpack_public_path__ + "Flama-BlackItalic.ttf?32bbdae5ad21ec66be98c6062605c31c";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BlackItalic.ttf
// module id = 910
// module chunks = 0